module.exports = __webpack_public_path__ + "img/logo.d1b26f4b.svg";